/* eslint-disable simple-import-sort/imports */
import { createFromJS } from "../../types";
import combineReducersWithGlobal from "../combineReducersWithGlobal";
import { actionTypes as syncSettingsActionTypes } from "../sync/settings/actions";
import { actionTypes } from "./actions";
import calendar from "./calendar";
import defaultColumns from "./defaultColumns";
import mindmapViewSettings from "./mindmapViewSettings";
import narrativeViewSettings from "./narrativeViewSettings";
import relationshipViewSettings from "./relationshipViewSettings";
import subwayViewSettings from "./subwayViewSettings";
import timelineViewSettings from "./timelineViewSettings";

//#!if readonly !== true
// import colors from "./colors";
// import types from "./types";
// import references from "./references";
// import properties from "./properties";
// import narrativeSettings from "./narrativeSettings";
//#!endif

//#!if iOS === true || harvard === true
import mobileItemCardViewSettings from "./mobileItemCardViewSettings";
//#!endif

const combinedReducers = combineReducersWithGlobal(createFromJS.TimelineDefinitionsRecord({}), {
  //#!if readonly !== true
// colors,
// types,
// properties,
// references,
// narrativeSettings,
  //#!endif
  defaultColumns,
  calendar,
  timelineViewSettings,
  narrativeViewSettings,

  relationshipViewSettings,
  mindmapViewSettings,
  subwayViewSettings,
  //#!if iOS === true || harvard === true
  mobileItemCardViewSettings
  //#!endif
});

const reducer = (state = createFromJS.TimelineDefinitionsRecord({}), action, globalState) => {
  let result = state;
  switch (action.type) {
    case actionTypes.REPLACE_DEFINITIONS:
      result = action.definitions;
      break;
    case actionTypes.CHANGE_INCLUDE_NARRATIVE:
      result = state.set("includeNarrative", action.includeNarrative);
      break;
    case actionTypes.SET_AUTO_ADJUST_LEVEL:
      result = state.set("autoAdjustLevel", action.level);
      break;
    case actionTypes.SET_AUTO_ADJUST_BACKWARDS_LIMIT:
      result = state.set("autoAdjustBackwardsLimit", action.limit);
      break;
    case actionTypes.SET_STORE_RELATIVE_PATHS:
      result = state.set("storeRelativePaths", action.value);
      break;
    case actionTypes.SET_OVERRIDE_NOW_TIMESTAMP:
      result = state.set("overrideNowTimestamp", action.timestamp);
      break;
    //#!if readonly !== true
// case syncSettingsActionTypes.REPLACE_SETTINGS:
// result = action.settings.enabled ? state.set("includeNarrative", true) : state;
// break;
    //#!endif
  }
  return combinedReducers(result, action, globalState);
};

export default reducer;
